
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceInwardTaxGrid extends Serenity.EntityGrid<ServiceInwardTaxRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseTax'; }
        protected getIdProperty() { return ServiceInwardTaxRow.idProperty; }
        protected getInsertPermission() { return ServiceInwardTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceInwardTaxRow.localTextPrefix; }
        protected getService() { return ServiceInwardTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

    }
}